var _circle, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSoccer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 12 12",
    enableBackground: "new 0 0 12 12",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_2_",
    cx: 7.939,
    cy: 2.3315,
    r: 10.8098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDFDFC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.262,
    style: {
      stopColor: "#FAFAF9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4505,
    style: {
      stopColor: "#F1F1F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    style: {
      stopColor: "#E1E1E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7681,
    style: {
      stopColor: "#CBCBCB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9099,
    style: {
      stopColor: "#AEAFB0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#98999A"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "url(#SVGID_2_)",
    cx: 5.999,
    cy: 5.965,
    r: 5.965
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#878783",
    d: "M5.726,11.677l-0.008-0.071c0.002,0,0.253-0.031,0.548-0.285c0.273-0.236,0.641-0.716,0.843-1.668 c0.433-2.042-0.094-3.659-0.1-3.676l0.068-0.023C7.083,5.97,7.616,7.606,7.179,9.667c-0.207,0.975-0.588,1.469-0.872,1.711 C5.997,11.644,5.737,11.676,5.726,11.677z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#878783",
    d: "M11.566,7.187C10.835,5.347,9.6,4.492,8.693,4.098C7.71,3.671,6.892,3.679,6.883,3.679L6.882,3.607 c0.008,0,0.843-0.008,1.839,0.424c0.585,0.254,1.112,0.608,1.565,1.053c0.566,0.555,1.019,1.254,1.346,2.076L11.566,7.187z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#878783",
    d: "M7.009,3.476L6.951,3.433C7.203,3.09,7.613,2.407,8.01,1.746c0.255-0.424,0.495-0.824,0.679-1.111 l0.06,0.039C8.566,0.96,8.326,1.36,8.072,1.783C7.674,2.445,7.263,3.13,7.009,3.476z"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#878783",
    d: "M6.634,3.554c-0.004-0.007-0.381-0.683-1.139-1.26C4.797,1.762,3.622,1.209,1.992,1.588l-0.016-0.07 c0.732-0.17,1.436-0.171,2.092-0.003C4.593,1.65,5.088,1.894,5.541,2.238c0.77,0.586,1.153,1.274,1.157,1.281L6.634,3.554z"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#878783",
    d: "M0.981,9.144L0.911,9.131c0.831-4.239,3.982-4.541,5.328-4.67C6.386,4.447,6.513,4.435,6.61,4.42 l0.011,0.071C6.522,4.506,6.394,4.518,6.245,4.532C4.916,4.66,1.803,4.958,0.981,9.144z"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#373735",
    points: "8.046,1.787 5.273,2.078 4.693,4.805 7.108,6.199 9.18,4.334  "
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#373735",
    d: "M1.23,2.381l1.599-0.944V0.911C2.252,1.285,1.647,1.836,1.23,2.381z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#373735",
    d: "M7.639,0.229l0.865,0.769L9.69,1.279c0,0-0.483-0.404-0.771-0.573C8.377,0.388,7.639,0.229,7.639,0.229z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#878783",
    d: "M5.37,11.073c-1.687,0-3.239-1.534-3.533-1.913l0.057-0.044c0.29,0.374,1.819,1.886,3.476,1.886V11.073z"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#878783",
    d: "M9.115,10.545l-0.04-0.06c0.688-0.459,1.218-1.074,1.573-1.829l0.065,0.031 C10.352,9.453,9.814,10.078,9.115,10.545z"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#878783",
    d: "M11.64,5.904l-0.07-0.018c0.155-0.618,0.009-1.547-0.4-2.55c-0.345-0.844-0.927-1.547-1.081-1.713l0,0 c0.217,0.184,0.796,0.827,1.147,1.686C11.652,4.326,11.799,5.271,11.64,5.904z"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#878783",
    d: "M0.451,6.375C0.207,5.184,0.441,3.348,1.173,2.458l0,0C0.851,2.849,0.619,3.529,0.5,4.289 C0.389,4.998,0.397,5.753,0.522,6.361L0.451,6.375z"
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#373735",
    d: "M1.26,9.66L2.39,9.624L2.106,6.368L0.398,5.895L0.034,6.368C0.034,7.501,0.587,8.998,1.26,9.66z"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#373735",
    d: "M4.577,10.899l0.653,0.983c0.252,0.032,0.509,0.049,0.769,0.049c1.083,0,2.099-0.289,2.975-0.793 l0.369-0.792L7.187,9.15L4.577,10.899z"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#373735",
    d: "M10.42,9.15h0.623c0.583-0.921,0.921-2.013,0.921-3.184c0-0.023,0-0.304,0-0.327l-0.289-0.252l-0.91,0.23 L10.42,9.15z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoccer);
export default __webpack_public_path__ + "static/media/Soccer.2b29a53cf065aa58cee68686901535c1.svg";
export { ForwardRef as ReactComponent };